import { BaseSettings, BaseThemeType} from 'Shared/frontend/themes/BaseSettings';
import { Questrial } from 'Shared/frontend/fonts/Questrial';
import { merge } from 'Shared/frontend/merge';


export class IndieIslandSettings extends BaseSettings
{
	palette()
	{
		return {
			background: 'black',
			text: '#E2E2E2',
			feature: '#FCB03B',

			/* Eg the mobile nav colour */
			dimBackground: '#1C1513'
		};
	}

	fontIncludes()
	{
		return [ Questrial ];
	}

	fonts()
	{
		return {
			text: '"Kiwi Maru", serif',
			headings: '"Kiwi Maru", serif',
			buttons: '"Kiwi Maru", serif',
			desktopNav: '"Kiwi Maru", serif',
			mobileNav: '"Open Sans", sans-serif',
			subNav: '"Kiwi Maru", serif'
		};
	}

	siteTheme()
	{
		const base = super.siteTheme();

		const settings = merge(base, <Partial<BaseThemeType>>{
			/* Add base theme overrides here */
		});

		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}
}

